import React, { Component } from 'react';
import './App.css';
import firebase from 'firebase';
import Highlighter from "react-highlight-words";
import { Link } from 'react-router-dom';

class App extends Component {
  constructor() {
    super();
    this.state = {
      question: "",
      correctAnswer: "",
      answer: "",
      randomIndex: 0,
      isSubmitted: false,
      totalQuestions: 0,
      answered: []
    };
    
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleNext = this.handleNext.bind(this);
    
    this.rootRef = firebase.database().ref();
    this.questionsRef = this.rootRef.child('Questions');
  }

  // call once after component is rendered in DOM
  componentDidMount() {
    console.log('componentDidMount', this.state.randomIndex);

    this.questionsRef.on('value', snap => { 
      var questionCount = snap.numChildren();
      var randomNum = Math.floor(Math.random() * questionCount + 1);
      while (this.state.answered.includes(randomNum) > 0){
        randomNum = Math.floor(Math.random() * questionCount + 1);
      }
      this.setState({
        totalQuestions: questionCount,
        randomIndex: randomNum
      }, () =>  {
        this.questionsRef.child(this.state.randomIndex).on('value', snap => { 
          this.setState({
            question: snap.val().Question,
            correctAnswer: snap.val().Answer
          });
        });
      });
    });
  }

  componentDidUpdate() {
    console.log('componentDidUpdate', this.state.randomIndex);
  }

  handleChange(event) {
    this.setState({
      answer: event.target.value
    });
  }

  handleSubmit(event) {
    this.setState({
      isSubmitted: true  
    });
    event.preventDefault();
  }

  handleNext() {
    this.setState({
      isSubmitted: false,
      answer: "",
      answered: this.state.answered.concat(this.state.randomIndex)
    }, () => {
      console.log("Next question", this.state.answered);

      this.questionsRef.on('value', snap => { 
        var randomNum = Math.floor(Math.random() * this.state.totalQuestions + 1);
        while (this.state.answered.includes(randomNum) > 0){
          randomNum = Math.floor(Math.random() * this.state.totalQuestions + 1);
        }
        this.setState({
          randomIndex: randomNum
        }, () =>  {
          this.questionsRef.child(this.state.randomIndex).on('value', snap => { 
            this.setState({
              question: snap.val().Question,
              correctAnswer: snap.val().Answer
            });
          });
        });
      });
    });
    //event.preventDefault();
  }

  render() {
    console.log('Render', this.state.randomIndex);
    return (
      <div className="App">
        {this.state.randomIndex !== 0 &&
            <div>
              <p id="title"><Link to="/" id="titleLink">Data Science Interview Questions</Link></p>
              <form onSubmit={this.handleSubmit}>
                {<h1 id="question">{this.state.randomIndex}. {this.state.question}</h1>}
                {!this.state.isSubmitted && 
                  <div>
                    <textarea defaultValue={this.state.answer} 
                              onChange={this.handleChange}
                              placeholder="Type your answer here..." required></textarea>
                    <input id="submitBtn" type="submit" value="Submit" />
                  </div>
                }
              </form>
            </div>
        }
        
        {this.state.isSubmitted && 
          <div>
            <div id="highlightBox">
              <Highlighter
                  highlightClassName="highlightResult"
                  searchWords={this.state.correctAnswer.split(" ")}
                  autoEscape={true}
                  textToHighlight={this.state.answer}/>
            </div>
            <div id="correctAnswer">
              <b>Correct Answer: </b>
              <br></br>
              <br></br>
              {this.state.correctAnswer}
            </div>
            {this.state.answered.length !== this.state.totalQuestions - 1 && <input id="nextBtn" type="submit" value="Next Question" onClick={this.handleNext}/>}
            {this.state.answered.length === this.state.totalQuestions - 1 && <p id="finished">Congratulations! You've finished all questions.</p>}
          </div>  
        }
      </div>
    );
  }
}  

export default App;
